/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/




// Imports MUI Components
import {
  Box,
  Grid,
  Stack
} from "@mui/material"

// Import Atoms
import ButtonComp from "../../atoms/button/Button"

// Import Molecules
import HeaderHoverableLogo from '../../molecules/header/HeaderHoverableLogo'
import HeaderButtonGroup from '../../molecules/header/HeaderButtonGroup'
import FooterCard from "../../molecules/footer/FooterCard.jsx"
import FooterCredits from "../../molecules/footer/FooterCredits.jsx"

const Footer = () => {

  const boxStylesWrapper = {
    // width: "100%",
    backgroundColor: "#2E2D2D",
    justifyContent: "center",
    alignItems: "center",
  }

  const boxStylesContent = {
    width: "100%",
    maxWidth: "1740px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "transparent"
  }
  
  return (
    <>
      <Box
        sx={boxStylesWrapper}
      >

        <Box
          sx={boxStylesContent}
        >

          <FooterCard/>

          <FooterCredits/>
            
        </Box>
      </Box>
    </>
  )

}

export default Footer;